import { render, staticRenderFns } from "./Registro-newUser.vue?vue&type=template&id=1c1be0a6&"
import script from "./Registro-newUser.vue?vue&type=script&lang=js&"
export * from "./Registro-newUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports